import { render, staticRenderFns } from "./replacedPolicyDetailModal.vue?vue&type=template&id=2041d76c&scoped=true&"
import script from "./replacedPolicyDetailModal.vue?vue&type=script&lang=js&"
export * from "./replacedPolicyDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./replacedPolicyDetailModal.vue?vue&type=style&index=0&id=2041d76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041d76c",
  null
  
)

export default component.exports